import axios from 'axios';
const BACKEND_API = 'https://api-venom.dexify.finance/';
// const BACKEND_API = 'http://localhost:3000/'
export const backendInstance = axios.create({ baseURL: BACKEND_API });
